import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import {ListsContext} from '../App';

export default function AddButton(props) {
  const [open, setOpen] = React.useState(false); 
  const [itemName, setItemName] = React.useState('');

  function handleOk(addItem) {
    setOpen(false);
    if (itemName !== '') {
      addItem(itemName);
    }
    setItemName('');
  }

  return (
    <div className="app-add">
      <Button variant="outlined" onClick={() => setOpen(true)} className="add-btn" fullWidth>
        Add item
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="additem-dialog-title"
        aria-describedby="additem-dialog-description">
        <DialogTitle id="additem-dialog-title">Add item</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            id="item-name"
            placeholder="Item name"
            onChange={(event) => setItemName(event.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <ListsContext.Consumer>
          {
            (context) => (
              <Button onClick={() => handleOk(context.addItem)} color="secondary">
                Add
              </Button>
            )
          }
          </ListsContext.Consumer>
        </DialogActions>
      </Dialog>
    </div>
  );
}